export const MIGRATIONS = [
    {
        version: 1,
        name: 'initial-local-schema',
        statements: [
            // ---------------------------------------------------------------
            // Device / identity
            // ---------------------------------------------------------------
            `CREATE TABLE local_device (
        id TEXT PRIMARY KEY,
        device_code TEXT NOT NULL,
        tenant_id TEXT NOT NULL,
        property_id TEXT NOT NULL,
        server_url TEXT NOT NULL DEFAULT '',
        app_version TEXT NOT NULL DEFAULT '',
        enrolled_at TEXT NOT NULL,
        created_at TEXT NOT NULL,
        singleton INTEGER NOT NULL DEFAULT 1 CHECK (singleton = 1)
      )`,
            // Exactly one device row per database file.
            `CREATE UNIQUE INDEX idx_local_device_singleton ON local_device(singleton)`,
            `CREATE TABLE local_session (
        id TEXT PRIMARY KEY,
        user_id TEXT NOT NULL,
        started_at TEXT NOT NULL,
        last_used_at TEXT NOT NULL,
        expires_at TEXT NOT NULL,
        ended_at TEXT
      )`,
            `CREATE INDEX idx_local_session_user ON local_session(user_id, started_at)`,
            `CREATE TABLE local_config (
        key TEXT PRIMARY KEY,
        value TEXT NOT NULL,
        updated_at TEXT NOT NULL
      )`,
            `CREATE TABLE local_audit (
        id INTEGER PRIMARY KEY AUTOINCREMENT,
        user_id TEXT,
        action TEXT NOT NULL,
        entity TEXT NOT NULL,
        entity_id TEXT,
        summary TEXT NOT NULL,
        metadata_json TEXT,
        at TEXT NOT NULL
      )`,
            `CREATE INDEX idx_local_audit_at ON local_audit(at)`,
            // ---------------------------------------------------------------
            // Replicas (server-owned master data; overwritten by pull)
            // ---------------------------------------------------------------
            `CREATE TABLE property (
        id TEXT PRIMARY KEY,
        name TEXT NOT NULL,
        legal_name TEXT,
        address TEXT,
        city TEXT,
        pincode TEXT,
        phone TEXT,
        email TEXT,
        gstin TEXT NOT NULL,
        state_code TEXT NOT NULL,
        fssai TEXT,
        currency TEXT NOT NULL DEFAULT 'INR',
        timezone TEXT NOT NULL DEFAULT 'Asia/Kolkata',
        settings_json TEXT NOT NULL DEFAULT '{}',
        updated_at TEXT
      )`,
            `CREATE TABLE users (
        id TEXT PRIMARY KEY,
        name TEXT NOT NULL,
        email TEXT NOT NULL,
        is_active INTEGER NOT NULL DEFAULT 1,
        role TEXT NOT NULL,
        offline_verifier TEXT,
        grant_json TEXT,
        grant_expires_at TEXT
      )`,
            `CREATE TABLE categories (
        id TEXT PRIMARY KEY,
        name TEXT NOT NULL,
        sort_order INTEGER NOT NULL DEFAULT 0
      )`,
            `CREATE TABLE menu_items (
        id TEXT PRIMARY KEY,
        category_id TEXT NOT NULL REFERENCES categories(id),
        sku TEXT NOT NULL,
        name TEXT NOT NULL,
        price_paise INTEGER NOT NULL,
        gst_rate_bp INTEGER NOT NULL,
        hsn TEXT NOT NULL,
        station TEXT NOT NULL,
        is_vegetarian INTEGER NOT NULL DEFAULT 1,
        discount_pct_bp INTEGER NOT NULL DEFAULT 0,
        is_active INTEGER NOT NULL DEFAULT 0,
        updated_at TEXT
      )`,
            `CREATE UNIQUE INDEX idx_menu_items_sku ON menu_items(sku)`,
            `CREATE INDEX idx_menu_items_active ON menu_items(is_active, category_id)`,
            // POS search is name/SKU contains-match over active items (Pos.tsx today).
            // Catalogue sizes are <= a few thousand rows: an index-assisted scan of
            // the active set is sub-millisecond, so no FTS (Phase 1 performance note).
            `CREATE INDEX idx_menu_items_name ON menu_items(name)`,
            `CREATE TABLE restaurant_tables (
        id TEXT PRIMARY KEY,
        code TEXT NOT NULL,
        seats INTEGER NOT NULL DEFAULT 2,
        section TEXT NOT NULL DEFAULT 'Main',
        is_active INTEGER NOT NULL DEFAULT 1
      )`,
            `CREATE UNIQUE INDEX idx_tables_code ON restaurant_tables(code)`,
            `CREATE TABLE stay_snapshots (
        id TEXT PRIMARY KEY,
        folio_no TEXT NOT NULL,
        room_number TEXT,
        guest_name TEXT NOT NULL,
        status TEXT NOT NULL,
        as_of TEXT NOT NULL
      )`,
            `CREATE TABLE entitlement (
        id INTEGER PRIMARY KEY CHECK (id = 1),
        is_entitled INTEGER NOT NULL DEFAULT 1,
        plan_name TEXT,
        grace_until TEXT,
        as_of TEXT NOT NULL
      )`,
            // ---------------------------------------------------------------
            // Transactions (device-owned; the sale path)
            // ---------------------------------------------------------------
            `CREATE TABLE orders (
        id TEXT PRIMARY KEY,
        property_id TEXT NOT NULL,
        number TEXT NOT NULL,
        type TEXT NOT NULL CHECK (type IN ('DINE_IN','TAKEAWAY','DELIVERY','ROOM_SERVICE')),
        status TEXT NOT NULL DEFAULT 'OPEN' CHECK (status IN ('OPEN','BILLED','POSTED_TO_ROOM','VOID')),
        table_id TEXT REFERENCES restaurant_tables(id),
        stay_id TEXT,
        covers INTEGER NOT NULL DEFAULT 1,
        note TEXT,
        void_reason TEXT,
        opened_by_user_id TEXT NOT NULL,
        opened_at TEXT NOT NULL,
        closed_at TEXT,
        updated_at TEXT NOT NULL,
        sync_state TEXT NOT NULL DEFAULT 'LOCAL' CHECK (sync_state IN ('LOCAL','QUEUED','SYNCED','CONFLICT'))
      )`,
            `CREATE UNIQUE INDEX idx_orders_number ON orders(number)`,
            `CREATE INDEX idx_orders_status ON orders(status, opened_at)`,
            `CREATE INDEX idx_orders_sync ON orders(sync_state)`,
            `CREATE TABLE order_lines (
        id TEXT PRIMARY KEY,
        order_id TEXT NOT NULL REFERENCES orders(id) ON DELETE CASCADE,
        menu_item_id TEXT NOT NULL,
        name TEXT NOT NULL,
        station TEXT NOT NULL,
        quantity_milli INTEGER NOT NULL CHECK (quantity_milli > 0),
        unit_price_paise INTEGER NOT NULL CHECK (unit_price_paise >= 0),
        discount_pct_bp INTEGER NOT NULL DEFAULT 0,
        gst_rate_bp INTEGER NOT NULL,
        hsn TEXT NOT NULL,
        note TEXT,
        kds_state TEXT NOT NULL DEFAULT 'QUEUED' CHECK (kds_state IN ('QUEUED','PREPARING','READY','SERVED')),
        fired_at TEXT NOT NULL,
        started_at TEXT,
        ready_at TEXT,
        served_at TEXT,
        updated_at TEXT NOT NULL
      )`,
            `CREATE INDEX idx_order_lines_order ON order_lines(order_id)`,
            // Per-order monotonic event trail (richer than the server's, by design).
            `CREATE TABLE order_events (
        id TEXT PRIMARY KEY,
        order_id TEXT NOT NULL REFERENCES orders(id) ON DELETE CASCADE,
        seq INTEGER NOT NULL,
        kind TEXT NOT NULL,
        payload_json TEXT,
        by_user_id TEXT,
        at TEXT NOT NULL
      )`,
            `CREATE UNIQUE INDEX idx_order_events_seq ON order_events(order_id, seq)`,
            `CREATE TABLE invoices (
        id TEXT PRIMARY KEY,
        property_id TEXT NOT NULL,
        number TEXT NOT NULL,
        kind TEXT NOT NULL DEFAULT 'FNB' CHECK (kind IN ('FNB','ROOM')),
        status TEXT NOT NULL DEFAULT 'PAID' CHECK (status IN ('PAID','POSTED_TO_ROOM','VOID')),
        order_id TEXT REFERENCES orders(id),
        guest_name TEXT NOT NULL DEFAULT 'Walk-in',
        guest_gstin TEXT,
        place_of_supply TEXT NOT NULL,
        is_inter_state INTEGER NOT NULL DEFAULT 0,
        subtotal_paise INTEGER NOT NULL,
        discount_paise INTEGER NOT NULL DEFAULT 0,
        cgst_paise INTEGER NOT NULL DEFAULT 0,
        sgst_paise INTEGER NOT NULL DEFAULT 0,
        igst_paise INTEGER NOT NULL DEFAULT 0,
        round_off_paise INTEGER NOT NULL DEFAULT 0,
        total_paise INTEGER NOT NULL,
        mode TEXT NOT NULL CHECK (mode IN ('CASH','CARD','UPI','ROOM','ONLINE')),
        void_reason TEXT,
        issued_by_user_id TEXT NOT NULL,
        issued_at TEXT NOT NULL,
        sync_state TEXT NOT NULL DEFAULT 'LOCAL' CHECK (sync_state IN ('LOCAL','QUEUED','SYNCED','CONFLICT'))
      )`,
            `CREATE UNIQUE INDEX idx_invoices_number ON invoices(number)`,
            `CREATE INDEX idx_invoices_issued ON invoices(issued_at)`,
            `CREATE INDEX idx_invoices_sync ON invoices(sync_state)`,
            `CREATE TABLE invoice_lines (
        id TEXT PRIMARY KEY,
        invoice_id TEXT NOT NULL REFERENCES invoices(id) ON DELETE CASCADE,
        description TEXT NOT NULL,
        hsn TEXT NOT NULL,
        quantity_milli INTEGER NOT NULL,
        unit_price_paise INTEGER NOT NULL,
        gst_rate_bp INTEGER NOT NULL,
        discount_paise INTEGER NOT NULL DEFAULT 0,
        taxable_paise INTEGER NOT NULL,
        cgst_paise INTEGER NOT NULL DEFAULT 0,
        sgst_paise INTEGER NOT NULL DEFAULT 0,
        igst_paise INTEGER NOT NULL DEFAULT 0,
        total_paise INTEGER NOT NULL
      )`,
            `CREATE INDEX idx_invoice_lines_invoice ON invoice_lines(invoice_id)`,
            // Device number series (ADR-011): same gapless-upsert discipline as the
            // server's document_sequences, scoped to this device.
            `CREATE TABLE local_sequences (
        doc_type TEXT NOT NULL,
        fiscal_year TEXT NOT NULL,
        next_value INTEGER NOT NULL DEFAULT 1,
        PRIMARY KEY (doc_type, fiscal_year)
      )`,
            // ---------------------------------------------------------------
            // Sync machinery (persistence only in Phase 2 - the engine is Phase 4)
            // ---------------------------------------------------------------
            `CREATE TABLE sync_queue (
        op_id TEXT PRIMARY KEY,
        seq INTEGER NOT NULL,
        kind TEXT NOT NULL,
        aggregate_id TEXT NOT NULL,
        payload_json TEXT NOT NULL,
        content_hash TEXT NOT NULL,
        created_at TEXT NOT NULL,
        attempts INTEGER NOT NULL DEFAULT 0,
        last_attempt_at TEXT,
        last_error TEXT,
        state TEXT NOT NULL DEFAULT 'PENDING' CHECK (state IN ('PENDING','SENT','DONE','REJECTED'))
      )`,
            `CREATE UNIQUE INDEX idx_sync_queue_seq ON sync_queue(seq)`,
            `CREATE INDEX idx_sync_queue_state ON sync_queue(state, seq)`,
            `CREATE INDEX idx_sync_queue_aggregate ON sync_queue(aggregate_id, seq)`,
            `CREATE TABLE sync_state (
        key TEXT PRIMARY KEY,
        value TEXT NOT NULL,
        updated_at TEXT NOT NULL
      )`,
            `CREATE TABLE sync_conflicts (
        id INTEGER PRIMARY KEY AUTOINCREMENT,
        op_id TEXT,
        aggregate_id TEXT,
        kind TEXT NOT NULL,
        server_detail_json TEXT,
        local_payload_json TEXT,
        raised_at TEXT NOT NULL,
        resolved_at TEXT,
        resolution TEXT
      )`,
            `CREATE INDEX idx_sync_conflicts_open ON sync_conflicts(resolved_at)`,
            `CREATE TABLE tombstones (
        entity TEXT NOT NULL,
        entity_id TEXT NOT NULL,
        at TEXT NOT NULL,
        PRIMARY KEY (entity, entity_id)
      )`,
        ],
    },
    {
        version: 2,
        name: 'menu-item-food-cost',
        statements: [
            // Display-only figure the POS tile shows ("32% FC"). Replicated so the
            // local grid matches the online grid; not used in any calculation.
            `ALTER TABLE menu_items ADD COLUMN food_cost_pct_bp INTEGER NOT NULL DEFAULT 0`,
        ],
    },
    {
        version: 3,
        name: 'offers-and-charges',
        statements: [
            // What a takeaway box, a delivery run and a table's service charge cost
            // the guest (docs/offline/phase-3-local-first-implementation.md): real
            // columns rather than the unused settings_json blob, matching this
            // file's float-free, one-value-per-column convention.
            `ALTER TABLE property ADD COLUMN packaging_takeaway_paise INTEGER NOT NULL DEFAULT 0`,
            `ALTER TABLE property ADD COLUMN packaging_delivery_paise INTEGER NOT NULL DEFAULT 0`,
            `ALTER TABLE property ADD COLUMN delivery_fee_paise INTEGER NOT NULL DEFAULT 0`,
            `ALTER TABLE property ADD COLUMN service_charge_pct_bp INTEGER NOT NULL DEFAULT 0`,
            // What an offer took off a settled ticket, frozen at settle time (the
            // server's Invoice.offers). NULL until a bill actually claims one.
            `ALTER TABLE invoices ADD COLUMN offers_json TEXT`,
            // Offer replica. Synced whether active or not (unlike the OfferRule[]
            // the live billing path reads) so a deactivated offer overwrites its
            // stale local row instead of going stale - the same idiom menu_items
            // already uses with is_active.
            `CREATE TABLE offers (
        id TEXT PRIMARY KEY,
        name TEXT NOT NULL,
        type TEXT NOT NULL CHECK (type IN ('BUY_X_GET_Y','SET_PRICE','PERCENT_OFF','COMBO')),
        sort_order INTEGER NOT NULL DEFAULT 0,
        is_active INTEGER NOT NULL DEFAULT 1,
        category_id TEXT,
        buy_qty INTEGER,
        free_qty INTEGER,
        set_qty INTEGER,
        set_price_paise INTEGER,
        percent_off_bp INTEGER,
        combo_price_paise INTEGER,
        min_ticket_paise INTEGER NOT NULL DEFAULT 0,
        max_per_ticket INTEGER NOT NULL DEFAULT 0,
        starts_on TEXT,
        ends_on TEXT,
        days_of_week TEXT NOT NULL DEFAULT '[]',
        start_minute INTEGER,
        end_minute INTEGER
      )`,
            `CREATE INDEX idx_offers_active ON offers(is_active, sort_order)`,
            `CREATE TABLE offer_items (
        offer_id TEXT NOT NULL REFERENCES offers(id) ON DELETE CASCADE,
        menu_item_id TEXT NOT NULL,
        quantity INTEGER NOT NULL DEFAULT 1,
        PRIMARY KEY (offer_id, menu_item_id)
      )`,
        ],
    },
];
/** Table names the validator asserts after migration (kept in step with MIGRATIONS). */
export const EXPECTED_TABLES = [
    'local_device',
    'local_session',
    'local_config',
    'local_audit',
    'property',
    'users',
    'categories',
    'menu_items',
    'restaurant_tables',
    'stay_snapshots',
    'entitlement',
    'orders',
    'order_lines',
    'order_events',
    'invoices',
    'invoice_lines',
    'local_sequences',
    'sync_queue',
    'sync_state',
    'sync_conflicts',
    'tombstones',
    'offers',
    'offer_items',
];
export const LATEST_SCHEMA_VERSION = MIGRATIONS[MIGRATIONS.length - 1]?.version ?? 0;
//# sourceMappingURL=schema.js.map